import { useEffect } from "react";
export function usePageMetadata(
  data: {
    metaTitle?: string;
    metaDescription?: string;
    socialImage?: string;
  } | null,
  fallback: string
) {
  useEffect(() => {
    document.title = data?.metaTitle || fallback;
    let meta = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]'
    );
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = data?.metaDescription || "";
    let social = document.querySelector<HTMLMetaElement>(
      'meta[property="og:image"]'
    );
    if (!social) {
      social = document.createElement("meta");
      social.setAttribute("property", "og:image");
      document.head.appendChild(social);
    }
    social.content = data?.socialImage
      ? new URL(data.socialImage, window.location.origin).href
      : "";
  }, [data?.metaTitle, data?.metaDescription, data?.socialImage, fallback]);
}
